import { generatePaginationOptions, updateUrlQueryParam } from "lib/helper"
import React, { useState, useRef, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useRouteMatch } from "react-router-dom"
import CampaignV2ListPanelComponent from "./campaignV2ListPanel.component"
import consumerApi from "app/api/consumer"
import { setCampaignV2ConsumerData, setIsLoadingCampaignV2ListError } from "modules/consumer/redux/slice/consumer.slice"

function CampaignV2ListPanelContainer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const match = useRouteMatch()
  const id = match.params.consumerId

  const list = useSelector(state => state.consumer.campaignV2List.data)
  const totalRecords = useSelector(state => state.consumer.campaignV2List.totalRecords)
  const totalFiltered = useSelector(state => state.consumer.campaignV2List.totalFiltered)
  const [isFetching, setIsFetching] = React.useState(false);
  const isError = useSelector(state => state.consumer.isLoadingCampaignV2ListError)
  const lang = useSelector(state => state.constant.languages)
  const language = useSelector(state => state.profile.language)
  const isSearchResult = list.length < totalRecords
  const [paginationOptions, setPaginationOptions] = useState([])
  const [isFilterUpdated, setIsFilterUpdated] = useState(false)
  const [tableFilter, setTableFilter] = useState({
    page: 0,
    rowsPerPage: 25,
    order: "desc",
    search: "",
    date: "",
    products: [],
    type: ""
  })

  const query = new URLSearchParams(window.location.search)
  const tableFilterInitialRef = useRef(true)

  useEffect(() => {
    const isFilter = query.has("is_filter")
    let filter = sessionStorage.getItem(`consumer_campaign_filter_${id}`);

    let temp = { ...tableFilter }
    if (isFilter && filter) {
      temp = JSON.parse(filter)
      setIsFilterUpdated(true)
    }

    if (isFilter) {
      updateUrlQueryParam(null, ["is_filter"])
    }
    sessionStorage.removeItem(`consumer_campaign_filter_${id}`)

    setTableFilter(temp)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!tableFilterInitialRef.current) {
      getData()
    }
    tableFilterInitialRef.current = false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableFilter, id])

  useEffect(() => {
    setPaginationOptions(generatePaginationOptions(totalFiltered))
  }, [totalFiltered])

  const getData = () => {
    setIsFetching(true);
    consumerApi.getConsumerCampaignV2Listing({
      id,
      length: tableFilter.rowsPerPage,
      start: tableFilter.rowsPerPage * tableFilter.page,
      order: tableFilter.order,
      search: tableFilter.search,
      date: tableFilter.date,
      products: tableFilter.products,
      type: tableFilter.type ? tableFilter.type.toLowerCase() : "",
    }).then(response => {
      dispatch(setCampaignV2ConsumerData(response.data));
    }).catch(() => {
      dispatch(setIsLoadingCampaignV2ListError(true));
    }).finally(() => {
      setIsFetching(false);
    });
  }

  const handleChangePage = (event, newPage) => {
    let newData = {
      ...tableFilter,
      page: newPage,
    }
    setIsFilterUpdated(true)
    setTableFilter(newData)
  }

  const handleChangeRowsPerPage = event => {
    let newData = {
      ...tableFilter,
      page: 0,
      rowsPerPage: event.target.value,
    }
    setIsFilterUpdated(true)
    setTableFilter(newData)
  }

  const handleFilter = (values) => {
    let newData = {
      ...tableFilter,
      page: 0,
      rowsPerPage: tableFilter.rowsPerPage,
      search: values.search,
      date: values.date,
      products: values.products,
      type: values.type,
    }

    setIsFilterUpdated(true)
    setTableFilter(newData)
  }

  const resetFilter = () => {
    let newData = {
      ...tableFilter,
      page: 0,
      search: "",
      date: "",
      products: [],
      type: ""
    }
    setIsFilterUpdated(false)
    setTableFilter(newData)
  }

  const changeOrder = (order) => {
    let newData = {
      ...tableFilter,
      order,
    }
    setIsFilterUpdated(true)
    setTableFilter(newData)
  }

  const handleViewDetail = (url) => {
    if (isFilterUpdated) {
      updateUrlQueryParam({ is_filter: true })
      sessionStorage.setItem(`consumer_campaign_filter_${id}`, JSON.stringify(tableFilter));
    }
    history.push(url)
  }

  return (
    <CampaignV2ListPanelComponent
      list={list}
      isFetching={isFetching}
      isError={isError}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      page={tableFilter.page}
      rowsPerPage={tableFilter.rowsPerPage}
      totalFiltered={totalFiltered}
      handleReload={getData}
      isSearchResult={isSearchResult}
      paginationOptions={paginationOptions}
      tableFilter={tableFilter}
      language={language}
      changeOrder={changeOrder}
      handleFilter={handleFilter}
      id={id}
      lang={lang}
      resetFilter={resetFilter}
      handleViewDetail={handleViewDetail}
    />
  )
}

export default CampaignV2ListPanelContainer
